// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  job: __t.string(),
  boldness: __t.u32(),
  greed: __t.u32(),
  diligence: __t.u32(),
  sociability: __t.u32(),
  homeX: __t.f32().name("home_x"),
  homeZ: __t.f32().name("home_z"),
  workX: __t.f32().name("work_x"),
  workZ: __t.f32().name("work_z"),
  wallet: __t.i64(),
  carry: __t.u32(),
  carryGood: __t.string().name("carry_good"),
  hunger: __t.u32(),
  needRest: __t.u32().name("need_rest"),
  needSocial: __t.u32().name("need_social"),
  mood: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
